/**
 * Navigation helpers: keyboard support, mobile accordion, sticky detection.
 */

/**
 * Closes the mobile nav when the Escape key is pressed.
 */
export function initNavigation() {
	const burger = document.querySelector( '.site-header__burger' );
	const nav    = document.querySelector( '.site-nav' );

	if ( ! burger || ! nav ) return;

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && nav.classList.contains( 'is-open' ) ) {
			burger.click();
			burger.focus();
		}
	} );
}

/**
 * Injects a chevron toggle button next to each parent link in the nav and wires
 * up accordion open/close for mobile. The buttons are hidden via CSS on desktop.
 */
export function initMobileSubmenu() {
	const nav = document.querySelector( '#menu-menu-top-festivals' );
	if ( ! nav ) return;

	const blocSociaLang = document.querySelector('.portal-bar__socials-lang');
	if (blocSociaLang) {
		const clone = blocSociaLang.cloneNode(true);
		clone.classList.add('clone-mobile-social');
		nav.appendChild(clone);
	}

	nav.querySelectorAll( '.menu-item-has-children' ).forEach( ( item ) => {
		const link    = item.querySelector( ':scope > a' );
		const subMenu = item.querySelector( ':scope > .sub-menu' );
		if ( ! link || ! subMenu ) return;

		const btn = document.createElement( 'button' );
		btn.className = 'site-nav__toggle';
		btn.type      = 'button';
		btn.setAttribute( 'aria-expanded', 'false' );
		btn.setAttribute( 'aria-label', 'Afficher le sous-menu' );
		btn.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true">' +
			'<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>' +
			'</svg>';

		link.insertAdjacentElement( 'afterend', btn );

		if (blocSociaLang) {
			const clone = blocSociaLang.cloneNode(true);
			clone.classList.add('clone'); // juste pour reconnaître les copies
			item.appendChild(clone);
		}

		btn.addEventListener( 'click', () => {
			const isOpen = item.classList.toggle( 'is-open' );
			btn.setAttribute( 'aria-expanded', String( isOpen ) );
		} );
	} );
}

/**
 * Adds `.is-scrolled` to `.site-header` when the page is scrolled past the top.
 * Also moves `.portal-bar__languages` into the sticky menu when scrolled.
 */
export function initStickyHeader() {
	const header = document.querySelector( '.site-header' );
	if ( ! header ) return;

	const lang         = document.querySelector( '.portal-bar__languages' );
	const menuFestival = document.querySelector( '#menu-menu-top-festivals' );
	const originalParent      = lang ? lang.parentNode : null;
	const originalNextSibling = lang ? lang.nextSibling : null;

	function update() {
		const isScrolled = window.scrollY > 0;
		header.classList.toggle( 'is-scrolled', isScrolled );

		if ( lang && menuFestival ) {
			if ( isScrolled ) {
				if ( ! menuFestival.contains( lang ) ) {
					menuFestival.appendChild( lang );
				}
			} else {
				if ( originalNextSibling ) {
					originalParent.insertBefore( lang, originalNextSibling );
				} else {
					originalParent.appendChild( lang );
				}
			}
		}
	}

	window.addEventListener( 'scroll', update, { passive: true } );
	update();
}
